'use client';

import type React from 'react';
import {
  QueryClient,
  QueryClientProvider as TanstackQueryClientProvider,
} from '@tanstack/react-query';

interface QueryClientProviderProperties {
  children: React.ReactNode;
}

const QUERY_CLIENT = new QueryClient();

export default function QueryClientProvider({
  children,
}: QueryClientProviderProperties) {
  return (
    <TanstackQueryClientProvider client={QUERY_CLIENT}>
      {children}
    </TanstackQueryClientProvider>
  );
}
